<template>
  <div class="main-wrapper" v-if="hosts">
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="服务器名称">
        <el-select v-model="searchForm.nodeName" placeholder="选择服务器名称">
          <el-option v-for="item in nodeNames" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="时间：从">
        <el-date-picker v-model="searchForm.dateFrom" type="date" placeholder="选择开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="searchForm.dateTo" type="date" placeholder="选择结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="searchForm.keyword" placeholder="关键字"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-switch v-model="searchForm.orderByIdDesc" active-text="按创建时间" inactive-text="按到期时间"></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="btnSearchClick">查询</el-button>
        <el-button type="primary" @click.prevent="btnAddClick">新建网站云</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="hosts" style="width: 100%">
      <el-table-column label="实例ID/名称" width="140">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
            target="_blank"
          >
            {{ getUniqueName(scope.row) }}
          </el-link>
          <br v-if="scope.row.nickName" />
          <el-link :underline="false" href="javascript:;">
            {{ scope.row.nickName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="绑定域名">
        <template #default="scope">
          <div v-if="scope.row.domains && scope.row.domains.length > 0">
            <div v-for="domain in scope.row.domains" :key="domain.id">
              <el-link type="primary" :underline="false" target="_blank" @click.prevent="btnCertsClick(scope.row)">
                {{ domain.domain }}
              </el-link>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户名" width="120">
        <template #default="scope">
          {{ scope.row.userName }}
        </template>
      </el-table-column>
      <el-table-column label="网站云类型" width="120">
        <template #default="scope">
          {{ getHostType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="磁盘空间" width="100">
        <template #default="scope">
          {{ getSize(scope.row.mbSize) }}
        </template>
      </el-table-column>
      <el-table-column label="PING" width="110" align="center">
        <template #default="scope">
          <el-alert
            v-if="scope.row.isRunning"
            :title="scope.row.isPingPong ? 'PONG' : 'PING'"
            :closable="false"
            :type="scope.row.isPingPong ? 'success' : 'error'">
          </el-alert>
        </template>
      </el-table-column>
      <el-table-column label="日期" width="140" align="center">
        <template #default="scope">
          <el-link
            :type="isExpiration(scope.row) ? 'danger' : 'success'"
            :underline="false"
            @click.prevent="btnShellClick(scope.row)"
          >
            {{ scope.row.createdDate }}
            <br />
            {{ scope.row.expirationDate }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template #default="scope">
          <el-dropdown @command="btnMoreClick">
            <el-link
              :type="scope.row.isRunning ? 'success' : 'danger'"
              :underline="false"
              href="javascript:;"
              class="el-dropdown-link"
            >
              {{ scope.row.isRunning ? '运行中' : '已停止' }}
              <i class="el-icon-arrow-down"></i>
            </el-link>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :disabled="scope.row.isRunning" :command="{ name: 'Start', host: scope.row }">
                  启动
                </el-dropdown-item>
                <el-dropdown-item :disabled="!scope.row.isRunning" :command="{ name: 'Stop', host: scope.row }">
                  停止
                </el-dropdown-item>
                <el-dropdown-item :command="{ name: 'Reload', host: scope.row }">重启</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <div class="actions">
            <el-link
              type="primary"
              :underline="false"
              @click.prevent="btnShellClick(scope.row)"
            >
              Shell
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click.prevent="btnCertClick(scope.row)"
            >
              更新证书
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click.prevent="btnEditClick(scope.row)"
            >
              编 辑
            </el-link>
            <el-link
              type="primary"
              :underline="false"
              @click.prevent="btnCredentialsClick(scope.row)"
            >
              凭 证
            </el-link>
            <el-link
              type="danger"
              :underline="false"
              @click.prevent="btnDeleteClick(scope.row)"
            >
              删 除
            </el-link>

            <el-link
              v-if="scope.row.isInstalled"
              type="primary"
              :underline="false"
              @click.prevent="btnConnectionClick(scope.row)"
              style="margin-right: 10px"
            >
              连接信息
            </el-link>
            <el-dropdown v-if="scope.row.isInstalled" @command="btnMoreClick">
              <el-link type="primary" :underline="false" href="javascript:;" class="el-dropdown-link">
                更多
                <i class="el-icon-arrow-down"></i>
              </el-link>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    :disabled="!scope.row.isRunning"
                    :command="{ name: 'Domains', host: scope.row }"
                  >
                    域名绑定
                  </el-dropdown-item>
                  <el-dropdown-item
                    :disabled="!scope.row.isRunning"
                    :command="{ name: 'ResetPassword', host: scope.row }"
                  >
                    重置密码
                  </el-dropdown-item>
                  <el-dropdown-item
                    :disabled="!scope.row.isRunning"
                    :command="{ name: 'Backups', host: scope.row }"
                  >
                    系统备份
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer title="新建网站云" direction="rtl" size="60%" v-model="isAdd">
      <el-form style="margin: 0 30px" ref="addForm" :model="addForm" label-position="top">
        <el-form-item label="服务器名称" prop="nodeName" :rules="{ required: true, message: '请输入服务器名称' }">
          <el-input v-model="addForm.nodeName" placeholder="服务器名称"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName" :rules="{ required: true, message: '请输入用户名' }">
          <el-input v-model="addForm.userName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="网站云类型" prop="hostType" :rules="{ required: true, message: '请选择网站云类型' }">
          <el-radio-group v-model="addForm.hostType">
            <el-radio label="Starter">入门版</el-radio>
            <el-radio label="Standard">标准版</el-radio>
            <el-radio label="Professional">专业版</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDate" :rules="{ required: true, message: '请选择到期时间' }">
          <el-date-picker v-model="addForm.expirationDate" type="date" placeholder="选择到期时间"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnAddSubmitClick">确 定</el-button>
          <el-button @click="isAdd = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="编辑网站云" direction="rtl" size="60%" v-model="isEdit">
      <el-form style="margin: 0 30px" ref="editForm" :model="editForm" label-position="top">
        <el-form-item label="用户名">
          {{ host.userName }}
        </el-form-item>
        <el-form-item label="实例ID/名称">
          <el-link
            type="primary"
            style="margin-right: 5px"
            :underline="false"
            :href="getUrl(host.hostName, host.nodeName, host.isHongKong)"
            target="_blank"
          >
            {{ getUniqueName(host) }}
          </el-link>
          <br v-if="host.nickName" />
          <el-link :underline="false" href="javascript:;">
            {{ host.nickName }}
          </el-link>
        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDate" :rules="{ required: true, message: '请选择到期时间' }">
          <el-date-picker v-model="editForm.expirationDate" type="date" placeholder="选择到期时间"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnEditSubmitClick">确 定</el-button>
          <el-button @click="isEdit = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="网站云凭证" direction="rtl" size="60%" v-model="isCredentials">
      <el-row :gutter="20">
        <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
          网站云实例ID/名称：
          <el-link type="primary" :underline="false" :href="getUrl(host.hostName, host.nodeName, host.isHongKong)" target="_blank">
            {{ getUniqueName(host) }}
            <span v-if="host.nickName">（{{ host.nickName }}）</span>
          </el-link>
        </el-col>
      </el-row>
      <el-form style="margin: 0 30px" ref="credentialsForm" :model="credentialsForm" label-position="top">
        <el-form-item label="SecurityKey" prop="securityKey" :rules="{ required: true, message: '请输入SecurityKey' }">
          <el-input v-model="credentialsForm.securityKey" placeholder="SecurityKey"></el-input>
        </el-form-item>
        <el-form-item v-if="host.hostType !== 'Starter'" label="FTP密码" prop="ftpPassword" :rules="{ required: true, message: '请输入FTP密码' }">
          <el-input v-model="credentialsForm.ftpPassword" placeholder="FTP密码"></el-input>
        </el-form-item>
        <el-form-item v-if="host.hostType === 'Professional'" label="数据库用户名" prop="databaseUser" :rules="{ required: true, message: '请输入数据库用户名' }">
          <el-input v-model="credentialsForm.databaseUser" placeholder="数据库用户名"></el-input>
        </el-form-item>
        <el-form-item v-if="host.hostType === 'Professional'" label="数据库密码" prop="databasePassword" :rules="{ required: true, message: '请输入数据库密码' }">
          <el-input v-model="credentialsForm.databasePassword" placeholder="数据库密码"></el-input>
        </el-form-item>
        <el-form-item v-if="host.hostType === 'Professional'" label="数据库名称" prop="databaseName" :rules="{ required: true, message: '请输入数据库名称' }">
          <el-input v-model="credentialsForm.databaseName" placeholder="数据库名称"></el-input>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnCredentialsSubmitClick">确 认</el-button>
          <el-button @click="isCredentials = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="网站云Shell" direction="rtl" size="60%" v-model="isShell">
      <el-form style="margin: 0 30px" label-position="top">
        <el-form-item label="Docker">
          <el-input v-model="shellResult.docker" :rows="6" type="textarea" />
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button @click="isShell = false">关 闭</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="连接信息" direction="rtl" size="60%" v-if="isConnections" v-model="isConnections">
      <el-table :data="connections" :show-header="false" style="width: 100%; margin: 0 10px" stripe size="large">
        <el-table-column prop="name" label="" width="180">
          <template #default="scope">
            <strong>{{ scope.row.name }}</strong>
          </template>
        </el-table-column>
        <el-table-column label="">
          <template #default="scope">
            <div v-html="scope.row.description"></div>
            <el-link v-if="scope.row.docUrl" type="primary" :underline="false" :href="scope.row.docUrl" target="_blank">
              使用帮助
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

    <el-drawer title="域名列表" direction="rtl" size="60%" v-if="isCerts" v-model="isCerts">
      <certs :userName="host.userName" :hostId="host.id" />
    </el-drawer>

    <el-drawer title="域名绑定" direction="rtl" size="60%" v-if="isDomains" v-model="isDomains">
      <domains :userName="host.userName" :hostId="host.id" />
    </el-drawer>

    <el-drawer title="系统备份" direction="rtl" size="40%" v-if="isBackups" v-model="isBackups">
      <backups :userName="host.userName" :hostId="host.id" />
    </el-drawer>

    <el-drawer
        title="重置密码"
        direction="rtl"
        size="60%"
        v-if="isResetPassword"
        v-model="isResetPassword"
      >
        <el-row :gutter="20">
          <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
            实例ID/名称：
            <el-link
              type="primary"
              :underline="false"
              :href="getUrl(host.hostName, host.nodeName, host.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(host) }}
              <span v-if="host.nickName">（{{ host.nickName }}）</span>
            </el-link>
          </el-col>
        </el-row>
        <el-alert
          :closable="false"
          title="如果超级管理员账号已存在，系统将重置密码，否则系统将新建超级管理员账号密码"
          type="error"
        ></el-alert>
        <el-form style="margin: 15px 30px 0" ref="resetPasswordForm" :model="resetPasswordForm" label-position="top">
          <el-form-item label="超级管理员账号" prop="userName" :rules="[{ required: true, message: '请输入超级管理员账号' }]">
            <el-input autocomplete="off" v-model="resetPasswordForm.userName" placeholder="请输入超级管理员账号"></el-input>
            <div class="tips">设置 SSCMS 后台的超级管理员账号</div>
          </el-form-item>
          <el-form-item label="超级管理员密码" prop="password" :rules="[{ required: true, message: '请输入超级管理员密码' }]">
            <el-input type="password" autocomplete="off" v-model="resetPasswordForm.password" placeholder="请输入自定义域名"></el-input>
            <div class="tips">设置 SSCMS 后台的超级管理员密码</div>
          </el-form-item>
          <el-form-item
            label="超级管理员确认密码"
            prop="confirmPassword"
            :rules="[{ required: true, message: '请输入确认密码' }, { validator: validatePass }]"
          >
            <el-input
              type="password"
              autocomplete="off"
              v-model="resetPasswordForm.confirmPassword"
              placeholder="请输入超级管理员确认密码"
            ></el-input>
            <div class="tips">请再次确认密码</div>
          </el-form-item>
          <el-divider></el-divider>

          <div class="el-dialog__footer">
            <el-button type="primary" @click="btnResetPasswordSubmitClick">确 定</el-button>
            <el-button @click="isResetPassword = false">取 消</el-button>
          </div>
        </el-form>
      </el-drawer>

  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import { defineComponent } from 'vue';
import { IHost } from '@/types/models';
import agentPing from '@/api/agent/ping';
import agentInstall from '@/api/agent/install';
import api, { IAddRequest, IEditRequest, IGetRequest, IShellResult } from '@/api/admin/hosts';
import { IElForm } from '@/types/element';
import { HostType } from '@/types/enums';
import Certs from './components/hosts/Certs.vue';
import Domains from './components/hosts/Domains.vue';
import Backups from './components/hosts/Backups.vue';

interface ICredentialsForm {
  hostId: number;
  securityKey: string;
  ftpPassword: string;
  databaseUser: string;
  databasePassword: string;
  databaseName: string;
}

interface IConnection {
  name: string;
  description: string;
  docUrl: string;
}

interface IResetPasswordForm {
  securityKey: string;
  guid: string;
  userName: string;
  password: string;
  confirmPassword: string;
}

interface IState {
  hosts: IHost[];
  nodeNames: string[];
  host: IHost;
  searchForm: IGetRequest;
  isAdd: boolean;
  addForm: IAddRequest;
  isEdit: boolean;
  editForm: IEditRequest;
  credentialsForm: ICredentialsForm;
  isCredentials: boolean;
  shellResult: IShellResult;
  isShell: boolean;
  isConnections: boolean;
  connections: IConnection[];
  isCerts: boolean;
  isDomains: boolean;
  isBackups: boolean;
  isResetPassword: boolean;
  resetPasswordForm: IResetPasswordForm;
}

export default defineComponent({
  components: {
    Certs,
    Domains,
    Backups,
  },
  data() {
    return {
      hosts: [],
      nodeNames: [],
      host: {} as IHost,
      searchForm: {
        nodeName: '',
        dateFrom: '',
        dateTo: '',
        keyword: '',
        orderByIdDesc: false,
      } as IGetRequest,
      isAdd: false,
      addForm: {} as IAddRequest,
      isEdit: false,
      editForm: {} as IEditRequest,
      credentialsForm: {} as ICredentialsForm,
      isCredentials: false,
      shellResult: {
        docker: '',
      } as IShellResult,
      isShell: false,
      isConnections: false,
      connections: [],
      isCerts: false,
      isDomains: false,
      isBackups: false,
      isResetPassword: false,
      resetPasswordForm: {} as IResetPasswordForm,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.searchForm, (res) => {
        this.hosts = res.hosts;
        this.nodeNames = res.nodeNames;

        for (const host of this.hosts) {
          host.isPingPong = true;
          if (host.isRunning) {
            host.isPingPong = false;
            this.apiPing(host);
          }
        }
      });
    },

    apiPing(host: IHost) {
      agentPing.ping(host.hostName, host.nodeName, host.isHongKong, (pong: string) => {
        if (pong === 'pong') {
          host.isPingPong = true;
        } else {
          host.isPingPong = false;
        }
      });
    },

    getUniqueName(host: IHost) {
      return utils.getHostUniqueName(host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getSize(mbSize: number) {
      return utils.getSize(mbSize);
    },

    isExpiration(host: IHost): boolean {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      const expirationDate = new Date(host.expirationDate);
      return expirationDate.getTime() <= date.getTime();
    },

    btnHostClick(host: IHost) {
      this.host = host;
    },

    btnDeleteClick(host: IHost) {
      utils.alertDelete(
        {
          title: '删除网站云',
          text: `此操作将删除网站云 ${this.getUniqueName(host)}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(host.id, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('网站云删除成功');
          });
        },
      );
    },

    btnSearchClick() {
      this.apiGet();
    },

    btnResetPasswordClick(host: IHost) {
      this.host = { ...host };
      api.resetPasswordGet(host.id, (res) => {
        this.resetPasswordForm.securityKey = res.securityKey;
        this.resetPasswordForm.guid = res.guid;
        this.resetPasswordForm.userName = '';
        this.resetPasswordForm.password = '';
        this.resetPasswordForm.confirmPassword = '';
        this.isResetPassword = true;
      });
    },

    btnMoreClick(args: { name: string; host: IHost }) {
      this.host = { ...args.host };
      if (args.name === 'Domains') {
        this.isDomains = true;
      } else if (args.name === 'ResetPassword') {
        this.btnResetPasswordClick(args.host);
      } else if (args.name === 'Backups') {
        this.isBackups = true;
      } else if (args.name === 'Start') {
        utils.alertDelete(
          {
            title: '启动实例',
            text: `此操作将启动实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认启动',
          },
          () => {
            api.start({ hostId: args.host.id }, () => {
              utils.success('实例启动成功！');
              this.apiGet();
            });
          },
        );
      } else if (args.name === 'Stop') {
        utils.alertDelete(
          {
            title: '停止实例',
            text: `此操作将停止实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认停止',
          },
          () => {
            api.stop({ hostId: args.host.id }, () => {
              utils.success('实例停止成功！');
              this.apiGet();
            });
          },
        );
      } else if (args.name === 'Reload') {
        utils.alertDelete(
          {
            title: '重启实例',
            text: `此操作将重启实例 ${this.getUniqueName(this.host)}，确定吗？`,
            button: '确认重启',
          },
          () => {
            api.reload({ hostId: args.host.id }, () => {
              utils.success('实例重启成功！');
              this.apiGet();
            });
          },
        );
      }
    },

    btnAddClick() {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth();
      const day = d.getDate();
      const expirationDate = new Date(year + 1, month, day);
      this.addForm = {
        nodeName: '',
        userName: '',
        hostType: HostType.Starter,
        expirationDate,
      } as IAddRequest;
      this.isAdd = true;
    },

    btnAddSubmitClick() {
      (this.$refs.addForm as IElForm).validate((valid) => {
        if (valid) {
          api.add(this.addForm, (res) => {
            if (!res) return;
            this.isAdd = false;
            this.apiGet();
            utils.success('网站云添加成功');
          });
        }
      });
    },

    btnCertsClick(host: IHost) {
      this.host = { ...host };
      this.isCerts = true;
    },

    btnEditClick(host: IHost) {
      this.host = { ...host };
      this.editForm = {
        hostId: this.host.id,
        expirationDate: this.host.expirationDate,
      } as IEditRequest;
      this.isEdit = true;
    },

    btnEditSubmitClick() {
      (this.$refs.editForm as IElForm).validate((valid) => {
        if (valid) {
          api.edit(this.editForm, (res) => {
            if (!res) return;
            this.isEdit = false;
            this.apiGet();
            utils.success('网站云修改成功');
          });
        }
      });
    },

    btnShellClick(host: IHost) {
      api.shell(host.id, (res) => {
        if (!res) return;
        this.isShell = true;
        this.shellResult = res;
      });
    },

    btnCertClick(host: IHost) {
      utils.alertDelete(
        {
          title: '更新域名HTTPS证书',
          text: `此操作将更新 ${this.getUniqueName(host)} 的域名HTTPS证书，确定吗？`,
          button: '确认更新',
        },
        () => {
          api.updateDomainsCert(host.id, (res) => {
            if (!res) return;
            utils.success('域名HTTPS证书更新成功！');
            this.apiGet();
          });
        },
      );
    },

    btnCredentialsClick(host: IHost) {
      this.host = { ...host };
      api.credentialsGet(host.userName, host.id, (res) => {
        if (!res) return;
        this.credentialsForm = {
          hostId: this.host.id,
          securityKey: res.securityKey,
          ftpPassword: res.ftpPassword,
          databaseUser: res.databaseUser,
          databasePassword: res.databasePassword,
          databaseName: res.databaseName,
        };
        this.isCredentials = true;
      });
    },

    btnCredentialsSubmitClick() {
      api.credentialsSubmit(this.credentialsForm, (res) => {
        if (!res) return;
        utils.success('网站云凭证保存成功');
        this.isCredentials = false;
      });
    },

    btnConnectionClick(host: IHost) {
      api.credentialsGet(host.userName, host.id, (res) => {
        this.connections = utils.getHostConnections(
          host,
          res.isHongKong,
          res.securityKey,
          res.ftpPassword,
          res.databaseHost,
          res.databaseUser,
          res.databasePassword,
          res.databaseName,
        );
        this.isConnections = true;
      });
    },

    apiAgentInstall(success: () => void) {
      agentInstall.install(
        this.host.hostName,
        this.host.nodeName,
        this.host.isHongKong,
        {
          securityKey: this.resetPasswordForm.securityKey,
          userName: this.resetPasswordForm.userName,
          password: this.resetPasswordForm.password,
        },
        (res) => {
          if (res.value) {
            success();
          }
        },
      );
    },

    apiResetPasswordSubmit() {
      api.resetPasswordSubmit(
        {
          hostId: this.host.id,
          userName: this.resetPasswordForm.userName,
          password: this.resetPasswordForm.password,
        },
        (res) => {
          if (res.value) {
            utils.success('恭喜，重置密码成功');
            this.isResetPassword = false;
            this.apiGet();
            utils.loading(false);
          }
        },
      );
    },

    btnResetPasswordSubmitClick() {
      this.apiAgentInstall(() => {
        this.apiResetPasswordSubmit();
      });
    },

    validatePass(rule: string, value: string, callback: (error?: Error) => void) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.resetPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
